import { Collection } from "../services/collection";
import { template as dashboard } from '../templates/tp-dashboard';

export class Dashboard extends Collection {
  constructor(auth?: any) {
    super('dashboard', {
      dashboard
    }, auth);
  }
}